import React, { Component } from 'react';
import { Button, FontIcon } from 'react-md';
import ReactTooltip from "react-tooltip";
import '../css/ButtonDashboard.css';
export default class ButtonDashboard extends Component {
  render() {
    return (
      <React.Fragment>
         <ReactTooltip  
            id="main"
            multiline={true}
            place = "top"
            type = "info"
            effect = "float"
            />
            <Button
        className="StyleButtonDashboard"
        primary
        flat
        iconBefore={false}
        svg={false}
        iconEl={<FontIcon primary>{this.props.icon}</FontIcon>}
        onClick={this.props.onCreateQuizSelect}
        data-tip={this.props.tooltipLabel?this.props.tooltipLabel:null}
        data-for="main"
      >
        {this.props.children}
      </Button>
      </React.Fragment>
      
    );
  }
}
